import styled from "styled-components";
export const StyledHeader = styled.header`
  width: 100%;
  display: flex;
  padding: 0 1rem;
  height: 60px;
  align-items: center;
  background-color: white;
  color: var(--primary-text);
  border-bottom: 1px solid #ddd;
  @media (max-width: 480px) {
    padding: 0 0.5rem;
  }
  .time_mngmt__header_actions {
    display: flex;
    align-items: center;
    gap: 1rem;
    margin-left: auto;
    @media (max-width: 640px) {
      gap: 0.5rem;
    }
    span {
      text-transform: capitalize;
      text-align: right;
    }
    .time_mngmt-notifications_icon {
      position: relative;
      cursor: pointer;
      width: 40px;
      height: 40px;
      border-radius: 100%;
      background-color: var(--primary-text);
      border: 0px solid var(--primary-text);
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.5s ease-in-out;

      svg {
        fill: white;
      }

      &:hover {
        background-color: var(--primary-text-hover);
      }

      @media (max-width: 640px) {
        width: 30px;
        height: 30px;

        svg {
          width: 15px;
        }
      }

      .icon-button__badge {
        position: absolute;
        top: -6px;
        right: -6px;
        width: 20px;
        height: 20px;
        background: red;
        color: #fff;
        font-size: 11px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        font-weight: bold;
      }
    }
    .time_mngmt__profile_icon {
      position: relative;
      cursor: pointer;
      width: 40px;
      height: 40px;
      border-radius: 100%;
      background-color: var(--primary-text);
      border: 0px solid var(--primary-text);
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.5s ease-in-out;

      svg {
        fill: white;
      }

      &:hover {
        background-color: var(--primary-text-hover);
      }

      @media (max-width: 640px) {
        width: 30px;
        height: 30px;

        svg {
          width: 15px;
        }
      }
    }
  }
`;

export const StyledHeaderLogo = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  a {
    display: flex;
    img {
      max-width: 150px;
    }
  }
  svg {
    cursor: pointer;
    border: 1px solid var(--primary-text);
    width: 30px;
    height: 30px;
    border-radius: 3px;
    transition: all 0.5s ease-in-out;
    display: none;
    @media (max-width: 1084px) {
      display: flex;
    }
  }
`;
